import Vue from "vue";

export async function fetchResult({ commit }, query) {
  try {
    const { data } = await Vue.axios({
      url: `/frontend/searchv?utf8=✓&term=${query}`
    });
    commit("setResult", data);
  } catch (e) {
    commit("resultError", e.message);
  } finally {
    // console.log("La petición para obtener el resultado ha finalizado");
  }
}